export function getBreakpointSize() {
  let size = 'L';
  if (window.matchMedia('(max-width: 600px)')?.matches) {
    size = 'S';
  } else if (window.matchMedia('(max-width: 900px)')?.matches) {
    size = 'M'
  }

  return size;
}

/**
Search an element and it's ancestors for a selector match.
*/
export function findParent(element, selector) {
  if (!element) {
    return null;
  }
  if (
    typeof selector === 'string' && element.matches(selector)
    || typeof selector === 'object' && element === selector
  ) {
    return element;
  }
  return findParent(element.parentElement, selector);
}

export function safeParseJson(string) {
  try {
    return JSON.parse(string);
  } catch(error) {
    console.warn(`could not parse json: ${string}`);
  }
}

export function debounce(func, delay = 500) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(
      () => {
        timeout = null;
        func(...args);
      },
      delay
    );
  };
}

export function getImageOrientation(image) {
  let orientation = 'horizontal';

  const rect = {
    width: image.naturalWidth,
    height: image.naturalHeight,
  };
  console.log({rect});

  if (rect.height > rect.width) {
    orientation = 'vertical';
  }

  return orientation;
}

export function a11yTest() {
  const imageAltAttributes = Array.from(document.images).map(image => image.alt);
  const badImages = Array.from(document.images).filter(image => !image.alt);

  badImages.forEach(image => {
    image.src = '';
    image.style.background = 'red';
  });

  console.log({
    imageAltAttributes,
    badImages,
  });
}
